export var LandmarksIds = {
    Menu: {
        Accessibility: 'nav-accessibility',
        Navigation: 'nav-menu',
    },
    Main: 'main-content',
    Footer: 'footer',
};
